









































































































































import {
  computed,
  defineComponent,
  provide,
  Ref,
  ref,
  useFetch,
  useRouter,
  useRoute,
  watch,
  useContext,
  onMounted,
} from "@nuxtjs/composition-api";

import SkeletonLoader from "~/components/SkeletonLoader/index.vue";
import { useUiHelpers, useSearchProducts } from "~/composables";
import {
  getFilterConfig,
  isFilterEnabled,
} from "~/modules/catalog/category/config/FiltersConfig";
import PriceRangeSlider from "~/modules/catalog/category/components/filters/filterPrice/PriceRangeSlider.vue";

import type { Aggregation, AggregationOption } from "~/modules/GraphQL/types";
import {
  RemovableFilterInterface,
  SelectedFiltersInterface,
  useFilters,
} from "~/modules/catalog/category/components/filters/useFilters";
import { getBgColorValue, isMobile } from "~/helpers";
import { mapAgg } from "~/modules/catalog/category/helpers/mapAgg";
import { useCategoryPageStore } from "~/modules/catalog/category/stores/categoryPage";

export interface UseFiltersProviderInterface {
  selectedFilters: Ref<SelectedFiltersInterface>;
  filters: Ref<Aggregation[]>;
}

export default defineComponent({
  name: "LandingPageFilters",
  components: {
    SkeletonLoader,
    PriceRangeSlider,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, { emit }) {
    const route = useRoute();
    const router = useRouter();
    const { changeFilters, clearFilters, getFacetsFromURL, clearFiltersAgg } =
      useUiHelpers();
    const { fetchProducts, loading: aggLoading } = useSearchProducts();
    const removableFilters = ref(<RemovableFilterInterface[]>[]);
    const filters = ref<Aggregation[]>([]);
    const isLoading = ref(true);

    const categoryPageStore = useCategoryPageStore();
    const categoryIdKey = computed(() =>
      String(props.item?.category_id || "9999")
    );

    const activeIndexes = ref([]);
    const isOpenSize = ref(false);
    const isOpenColor = ref(false);
    const isOpenPrice = ref(false);
    const priceFilterMin = ref<number | null>(null);
    const priceFilterMax = ref<number | null>(null);

    const activeSizeGuide = ref<number[]>([]);
    const activePrice = ref<number[]>([]);
    const activeCateId = ref<number[]>([]);

    const toggleActive = (index) => {
      const i = activeIndexes.value.indexOf(index);
      if (i > -1) {
        activeIndexes.value?.splice(i, 1);
      } else {
        activeIndexes.value?.push(index);
      }
    };

    const positions = computed(() => {
      if (props.item?.positions && props.item.positions.length) {
        return props.item.positions;
      }

      const positionsToCheck = ["sizeguide", "category_ids", "final_price"];
      const foundPositions = [];

      if (props.item) {
        positionsToCheck.forEach((key) => {
          if (key in props.item) {
            foundPositions.push(key);
          }
        });
      }

      return foundPositions;
    });

    const filterByPosition = (position) => {
      return props.item?.[position] ? props.item?.[position]?.slice(1) : [];
    };
    const {
      selectedFilters,
      selectFilter,
      removeFilter,
      isFilterSelected,
      getRemovableFilters,
      getSelectedFiltersFromUrl,
    } = useFilters();

    const updateRemovableFilters = () => {
      removableFilters.value = getRemovableFilters(
        filters.value,
        selectedFilters.value
      );
      emit("removableFiltersChanged", removableFilters.value);
    };

    const doApplyFilters = () => {
      changeFilters(selectedFilters.value, false);
      updateRemovableFilters();
      emit("reloadProducts");
    };

    const doRemoveFilter = ({ id, value }: { id: string; value: string }) => {
      removeFilter(id, value);
      changeFilters(selectedFilters.value, false);
      updateRemovableFilters();
      emit("reloadProducts");
      emit("close");
    };

    const doClearFilters = () => {
      clearFiltersAgg(false);
      selectedFilters.value = {};
      updateRemovableFilters();
      emit("reloadProducts");
      emit("close");
    };

    const chooseFilter = (filter: Aggregation, option: AggregationOption) => {
      if (isFilterActive(option)) {
        removeFilter(filter.attribute_code, option.value);
      } else {
        selectFilter(filter, option);
      }
      doApplyFilters();
    };

    const changeFilterPrice = (option: AggregationOption) => {
      const filter = filters.value.find(
        (filter) => filter.attribute_code === "price"
      );
      selectFilter(filter, option);
      updateRemovableFilters();
      doApplyFilters();
    };

    const isFilterActive = (option: AggregationOption) => {
      return removableFilters.value.some(
        (item: AggregationOption) => item.value === option.value
      );
    };

    const getParamFilter = () => {
      let routerQuery;
      if (process?.client) {
        routerQuery = router?.resolve(
          (window?.location?.pathname + window?.location?.search)?.slice(1)
        )?.route?.query;
      } else {
        routerQuery = router?.currentRoute?.query;
      }
      let paramFilter: any = {};

      if (routerQuery && Object.keys(routerQuery).length > 0) {
        if (routerQuery?.sizeguide && routerQuery.sizeguide.length > 0) {
          paramFilter.sizeGuideIds = [];
          if (props.item?.sizeguide) {
            props.item.sizeguide.forEach((item) => {
              if (routerQuery.sizeguide?.includes(item.key)) {
                item.value?.forEach((value) => {
                  if (value) {
                    paramFilter.sizeGuideIds.push(value);
                  }
                });
              }
            });
          }
        }

        // if (routerQuery.final_price) {
        //   if (props.item?.final_price) {
        //     props.item.final_price.forEach((item) => {
        //       if (item.key == routerQuery.final_price) {
        //         paramFilter.price = item.value;
        //       }
        //     });
        //   }
        // }

        return paramFilter;
      }
    };

    const getParamIds = () => {
      let routerQuery;
      if (process?.client) {
        routerQuery = router?.resolve(
          (window?.location?.pathname + window?.location?.search)?.slice(1)
        )?.route?.query;
      } else {
        routerQuery = router?.currentRoute?.query;
      }
      let paramFilter: any = {};

      if (routerQuery?.category_ids && routerQuery?.category_ids.length > 0) {
        if (props.item?.category_ids) {
          paramFilter.ids = [];
          props.item.category_ids.forEach((item) => {
            if (routerQuery.category_ids?.includes(item.key)) {
              item.value?.forEach((value) => {
                if (value) {
                  paramFilter.ids.push(value);
                }
              });
            }
          });
        }
      } else {
        paramFilter.ids = [props.item?.category_id?.toString()];
      }
      return paramFilter;
    };

    const { fetch } = useFetch(async () => {
      const params = {
        ids: getParamIds()?.ids,
        pageSize: 1,
        filters: getParamFilter(),
        aggs: true,
      };
      const { aggregations } = await fetchProducts(params);

      filters.value = mapAgg(aggregations)
        .filter((filter) => isFilterEnabled(filter.attribute_code))
        .sort((a, b) => {
          const order = ["size", "mastercolor", "price"];
          return (
            order.indexOf(a.attribute_code) - order.indexOf(b.attribute_code)
          );
        });

      const priceFilter = filters.value.find(
        (filter) => filter.attribute_code === "price"
      );

      if (
        priceFilter &&
        priceFilter.options &&
        priceFilter.options.length > 0
      ) {
        const priceValues = priceFilter.options
          .map((option) => {
            return Number(option.value);
          })
          .filter((value) => !isNaN(value));

        if (priceValues.length > 0) {
          priceFilterMin.value = Math.min(...priceValues);
          priceFilterMax.value = Math.max(...priceValues);
        } else {
          priceFilterMin.value = -Infinity;
          priceFilterMax.value = Infinity;
        }
      } else {
        priceFilterMin.value = -Infinity;
        priceFilterMax.value = Infinity;
      }

      selectedFilters.value = getSelectedFiltersFromUrl();
      updateRemovableFilters();
    });

    const getIndexActive = () => {
      let routerQuery;
      if (process?.client) {
        routerQuery = router?.resolve(
          (window?.location?.pathname + window?.location?.search)?.slice(1)
        )?.route?.query;
      } else {
        routerQuery = router?.currentRoute?.query;
      }
      activePrice.value = [];
      activeSizeGuide.value = [];
      activeCateId.value = [];

      if (routerQuery?.final_price && props.item?.final_price) {
        const slicedFinalPrice = props.item.final_price.slice(1);
        const finalPrices = Array.isArray(routerQuery.final_price)
          ? routerQuery.final_price
          : [routerQuery.final_price];

        finalPrices.forEach((priceValue) => {
          const index = slicedFinalPrice?.findIndex(
            (item) => item.key === priceValue
          );
          if (index !== -1) {
            activePrice?.value.push(index);
          }
        });
      }

      if (routerQuery?.sizeguide && props.item?.sizeguide) {
        const slicedSizeGuide = props.item.sizeguide?.slice(1);
        const sizeGuides = Array.isArray(routerQuery.sizeguide)
          ? routerQuery.sizeguide
          : [routerQuery.sizeguide];

        sizeGuides.forEach((sizeValue) => {
          const index = slicedSizeGuide?.findIndex(
            (item) => item.key === sizeValue
          );
          if (index !== -1) {
            activeSizeGuide?.value.push(index);
          }
        });
      }

      if (routerQuery?.category_ids && props.item?.category_ids) {
        const slicedCategoryIds = props.item.category_ids.slice(1);
        const categoryIds = Array.isArray(routerQuery.category_ids)
          ? routerQuery.category_ids
          : [routerQuery.category_ids];

        categoryIds.forEach((categoryValue) => {
          const index = slicedCategoryIds.findIndex(
            (item) => item.key === categoryValue
          );
          if (index !== -1) {
            activeCateId?.value.push(index);
          }
        });
      }
    };

    onMounted(async () => {
      getIndexActive();
      // fetch();
      categoryPageStore.resetLandingPage(categoryIdKey.value);
    });

    const selectedFiltersLanding = ref<SelectedFiltersInterface>({});

    const checkActivePosition = (position, index) => {
      switch (position) {
        case "final_price":
          return activePrice.value?.includes(index);
        case "sizeguide":
          return activeSizeGuide.value?.includes(index);
        case "category_ids":
          return activeCateId.value?.includes(index);
        default:
          return false;
      }
    };

    const chooseFilterCate = async (position, option, index) => {
      switch (position) {
        case "final_price":
          if (activePrice.value.includes(index)) {
            activePrice.value = activePrice.value.filter((i) => i !== index);
          } else {
            activePrice.value = [...activePrice.value, index];
          }
          break;
        case "sizeguide":
          if (activeSizeGuide.value.includes(index)) {
            activeSizeGuide.value = activeSizeGuide.value.filter(
              (i) => i !== index
            );
          } else {
            activeSizeGuide.value = [...activeSizeGuide.value, index];
          }
          break;
        case "category_ids":
          if (activeCateId.value.includes(index)) {
            activeCateId.value = activeCateId.value.filter((i) => i !== index);
          } else {
            activeCateId.value = [...activeCateId.value, index];
          }
          break;
        default:
          break;
      }
      const preservedFilters: Record<string, any> = {};

      if (
        activeSizeGuide.value.length > 0 &&
        Array.isArray(props.item?.sizeguide)
      ) {
        preservedFilters.sizeguide = activeSizeGuide.value
          .map((i) => props.item?.sizeguide.slice(1)[i]?.key)
          .filter(Boolean);
      } else {
        preservedFilters.sizeguide = [];
      }

      if (
        activeCateId.value.length > 0 &&
        Array.isArray(props.item?.category_ids)
      ) {
        preservedFilters.category_ids = activeCateId.value
          .map((i) => props.item.category_ids.slice(1)[i]?.key)
          .filter(Boolean);
      } else {
        preservedFilters.category_ids = [];
      }

      if (
        activePrice.value.length > 0 &&
        Array.isArray(props.item?.final_price)
      ) {
        preservedFilters.final_price = activePrice.value
          .map((i) => props.item.final_price.slice(1)[i]?.key)
          .filter(Boolean);
      } else {
        preservedFilters.final_price = [];
      }

      selectedFiltersLanding.value = preservedFilters;

      clearFilters(false);
      changeFilters(preservedFilters, false);
      emit("reloadProducts");
      fetch();
      selectedFilters.value = {};
      updateRemovableFilters();
    };

    const getIndexPositions = (value) => {
      return positions.value.findIndex((position) => position === value);
    };

    provide("UseFiltersProvider", {
      isFilterSelected,
      selectedFilters,
      filters,
    });

    return {
      selectFilter,
      doApplyFilters,
      doRemoveFilter,
      doClearFilters,
      getFilterConfig,
      selectedFilters,
      filters,
      isLoading,
      removableFilters,
      isOpenSize,
      isOpenColor,
      isOpenPrice,
      chooseFilter,
      priceFilterMin,
      priceFilterMax,
      changeFilterPrice,
      isFilterActive,
      getBgColorValue,
      positions,
      filterByPosition,
      checkActivePosition,
      chooseFilterCate,
      toggleActive,
      activeIndexes,
      getIndexPositions,
      getIndexActive,
    };
  },
});
